import '@babel/polyfill'
import './modules/swiper'
import './modules/gsap'
// import './modules/bse-widget'
import './modules/flatpickr'

import GLightbox from 'glightbox'

import { pageLoad } from './modules/page-loader'
import { lazyLoading } from './modules/lazyload'
import { menuScroll } from './modules/menu-scroll'
import { contactForm } from './modules/contact-form'
import { hamburgerAnimate, openObjectsMenu } from './modules/hamburger'
import { slider } from './modules/slider'
import { registerTabPanel } from './modules/tab-panel'
import { registerAccordion } from './modules/accordion'

pageLoad()
lazyLoading()
menuScroll()
hamburgerAnimate()
openObjectsMenu()
registerTabPanel()
if (document.querySelector('.accordion')) {
    registerAccordion()
}

const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: false,
})
if (document.querySelector('.splide')) slider()
